import React, { createContext, useContext, useState, useEffect } from 'react';
import { authApi } from '../lib/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('safetydesk81_token');
    const storedUser = localStorage.getItem('safetydesk81_user');
    if (token && storedUser) {
      try { setUser(JSON.parse(storedUser)); } catch (e) { /* ignore */ }
      // Validate token silently in the background
      authApi.me().then((r) => {
        setUser(r.data);
        localStorage.setItem('safetydesk81_user', JSON.stringify(r.data));
      }).catch(() => {
        localStorage.removeItem('safetydesk81_token');
        localStorage.removeItem('safetydesk81_user');
        setUser(null);
      }).finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (username, password) => {
    try {
      const { data } = await authApi.login(username, password);
      localStorage.setItem('safetydesk81_token', data.access_token);
      localStorage.setItem('safetydesk81_user', JSON.stringify(data.user));
      setUser(data.user);
      return { success: true, user: data.user };
    } catch (err) {
      return { success: false, error: err.response?.data?.detail || 'Errore di accesso' };
    }
  };

  const logout = () => {
    localStorage.removeItem('safetydesk81_token');
    localStorage.removeItem('safetydesk81_user');
    setUser(null);
  };

  const isReadOnly = !!user?.readOnly;
  const menuAccess = Array.isArray(user?.menuAccess) ? user.menuAccess.map(String) : [];

  return (
    <AuthContext.Provider value={{ user, login, logout, loading, isReadOnly, menuAccess }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
};

// Returns true when the current user is in read-only mode.
export const useReadOnly = () => {
  const { isReadOnly } = useAuth();
  return isReadOnly;
};
